export default "__VITE_ASSET__C1KZ$iP2__"